import { Box } from "@mui/material";
import { useEffect } from "react";



export default function ToastMsg({showToast,setShowToast})
{
    useEffect(()=>{
        if(showToast)
        {
            setTimeout(()=>{
                setShowToast(null)
            },1500)
        }
    // eslint-disable-next-line
    },[showToast])

    return(
        <Box className={"toast-container"}>
            {
                showToast && showToast.message &&
                <Box className={`toast ${showToast?.error?"toast-error":"toast-success"}`} sx={{opacity:1,bgcolor:showToast?.color ? `${showToast?.color} !important`:""}}>
                    <Box className={"toast-message"}>
                        {showToast?.message}
                    </Box>
                </Box>
            }
        </Box>
    )
}